import { SearchResultItem } from '@smart-tv/typings/search';

import { kmm } from './kmm';
import { toKmmSearchResultItem } from './search-helpers';

export async function addToSearchHistory(item: SearchResultItem): Promise<boolean> {
  return kmm((repo) => repo.addToSearchHistory(toKmmSearchResultItem(item)));
}

export default addToSearchHistory;
